export const STEPS_SET = 'STEPS_SET';
export const STEP_ADD = 'STEP_ADD';
export const STEP_UPDATE_FORM_HTML = 'STEP_UPDATE_FORM_HTML';
export const STEP_UPDATE_ORIGINAL_FORM_HTML = 'STEP_UPDATE_ORIGINAL_FORM_HTML';
export const STEP_UPDATE_FORM_CUSTOMIZED = 'STEP_UPDATE_FORM_CUSTOMIZED';
export const STEP_UPDATE_REDIRECT_AUTOMATIC = 'STEP_UPDATE_REDIRECT_AUTOMATIC';
export const STEP_UPDATE_REDIRECT_URL = 'STEP_UPDATE_REDIRECT_URL';
export const STEP_UPDATE_REDIRECT_BUTTON_TEXT = 'STEP_UPDATE_REDIRECT_BUTTON_TEXT';
export const STEP_UPDATE_MULTIPLE_ANSWER = 'STEP_UPDATE_MULTIPLE_ANSWER';
export const STEP_SET_ACTIVE = 'STEP_SET_ACTIVE';
export const STEP_UPDATE_TITLE = 'STEP_UPDATE_TITLE';
export const STEP_REMOVE = 'STEP_REMOVE';
export const STEP_UPDATE_QUIZ_ID = 'STEP_UPDATE_QUIZ_ID';
export const STEP_UPDATE_REDIRECT_EMAIL_SERVICE = 'STEP_UPDATE_REDIRECT_EMAIL_SERVICE';
export const STEP_UPDATE_DESCRIPTION_VISIBILITY = 'STEP_UPDATE_DESCRIPTION_VISIBILITY';
export const STEP_UPDATE_DESCRIPTION = 'STEP_UPDATE_DESCRIPTION';
export const STEP_UPDATE_WELCOME_ACTIVE = 'STEP_UPDATE_WELCOME_ACTIVE';
export const STEP_UPDATE_WELCOME_OPTION = 'STEP_UPDATE_WELCOME_OPTION';
export const STEP_UPDATE_TEXT_REQUIRED = 'STEP_UPDATE_TEXT_REQUIRED';
export const STEP_UPDATE_TEXT_SIZE = 'STEP_UPDATE_TEXT_SIZE';
export const STEP_UPDATE_TEXT_PLACEHOLDER = 'STEP_UPDATE_TEXT_PLACEHOLDER';
export const STEP_UPDATE_NEXT_BUTTON_TEXT = 'STEP_UPDATE_NEXT_BUTTON_TEXT';
export const STEP_UPDATE_POSITIONS = 'STEP_UPDATE_POSITIONS';
export const STEP_RESET_STATE = 'STEP_RESET_STATE';
export const STEP_PUSH = 'STEP_PUSH';
export const STEP_SET_STYLES = 'STEP_SET_STYLES';
export const STEP_UPDATE_STYLE = 'STEP_UPDATE_STYLE';
export const STEP_SET_PREVIEW = 'STEP_SET_PREVIEW';



/** WEBPACK FOOTER **
 ** ./src/store/modules/step/types.js
 **/